import React, { useRef } from "react";
import { AttributeDefinition, AttributeTargetType, GetComponentOrStyleValueFromDefinition } from "../Data/WBData";
import { UpdateStyleFunction } from "../Stylebuilder";
import { AttributeFieldProps } from "./RenderAttributeInput";

export default function FourDirectionFowField({label,definition,layoutObject,updateFunc,saveFunc,screenSize,siteData}:AttributeFieldProps){

let val = GetComponentOrStyleValueFromDefinition(definition,layoutObject,screenSize);

let split = val.replaceAll(" ","").split("px");

let getTop = "0";
let getRight = "0";
let getBottom = "0";
let getLeft = "0";

if(split.length>0)
 getTop = split[0];

for(let i = 0;i<split.length;i++){
    if(split[i]==""){
        split[i]="0";
    }
}

if(split.length >= 4){


    getRight = split[1];
    getBottom = split[2];
    getLeft = split[3];



}
else{
    getRight =getTop;
    getBottom = getTop;
    getLeft = getTop;
}



const topRef = useRef<HTMLInputElement>(null);
const rightRef = useRef<HTMLInputElement>(null);
const bottomRef = useRef<HTMLInputElement>(null);
const leftRef = useRef<HTMLInputElement>(null);


const updateAll= (attributeKey:string,attributeValue:string,targetType:AttributeTargetType)=>{
    if(topRef.current && rightRef.current && bottomRef.current && leftRef.current){
    
        let top = topRef.current.value;
        let right = rightRef.current.value;
        let bottom = bottomRef.current.value;
        let left = leftRef.current.value;

        if(top=="")
            top = "0";
        if(right=="")
            right = "0";
        if(bottom=="")
            bottom = "0";
        if(left=="")
            left = "0";

        const newVal = `${top}px ${right}px ${bottom}px ${left}px`
  
        updateFunc(definition.attKey,newVal,definition.targetType);
    }
 

}

const useCorners = definition.attKey.toLowerCase().includes("radius");

return (

    <div className="wb-input-group flex-column no-border fourway center-all">
        <div className="relative center-all" style={{width:"110px",height:"110px",borderRadius:"4px",background:"#00000011",border:"2px dashed grey",margin:"30px 0"}}>
 
        { useCorners?
            <>
        <RenderDirField label={"Top Left"} x={-1} y={-1} definition={definition} defaultValue={getTop} updateFunc={updateAll} setRef={topRef}/>
        <RenderDirField label={"Top Rght"} x={1} y={-1} definition={definition} defaultValue={getRight} updateFunc={updateAll} setRef={rightRef}/>
        <RenderDirField label={"Btm Left"} x={-1} y={1} definition={definition} defaultValue={getLeft} updateFunc={updateAll} setRef={leftRef}/>
        <RenderDirField label={"Btm Rght"} x={1} y={1} definition={definition} defaultValue={getBottom} updateFunc={updateAll} setRef={bottomRef}/>


            </>
        :
        <>
        <RenderDirField label={"Top"} x={0} y={-1}      definition={definition} defaultValue={getTop} updateFunc={updateAll} setRef={topRef}/>
        <RenderDirField label={"Bottom"} x={0} y={1}    definition={definition} defaultValue={getBottom} updateFunc={updateAll} setRef={bottomRef}/>
        <RenderDirField label={"Left"}  x={-1} y={0}    definition={definition} defaultValue={getLeft} updateFunc={updateAll} setRef={leftRef}/>
        <RenderDirField label={"Right"} x={1} y={0}     definition={definition} defaultValue={getRight} updateFunc={updateAll} setRef={rightRef}/>
        </>
        }
    </div>
        </div>
);


}


function RenderDirField({label,definition,defaultValue,updateFunc,setRef,x,y}:{x:number,y:number,isCornered?:boolean,label:string,definition:AttributeDefinition,defaultValue:string,updateFunc:UpdateStyleFunction,setRef:any}){

    let isCorner = (x!=0&&y!=0);
    if(isCorner){
    
        y= y*.82;
    }
    let inputWidth = 80;
    let inputHeight = 40;
    let offset = 60;



    let style:any = {
        position:"absolute",

        width:`${inputWidth}px`,
        left:`calc(50% - ${inputWidth/2}px)`,
        top:`calc(50% - ${inputHeight/2}px)`,
        transform:`translate(${x*offset}px,${y*offset}px)`,
     
    }

    return (

        <div className="fourway-measurement-unit" style={style}>
            <div className="range-text">
            <input ref={setRef} type="number"  min={(definition.attribute.toLowerCase().includes("padding")||definition.attribute.toLowerCase().includes("radius")?0:-99999)}  defaultValue={defaultValue} placeholder="0" onChange={(e)=>{updateFunc(definition.attKey,e.target.value,definition.targetType)}}/>
            <span>px</span>
            </div>
        </div>
    )

}